// Client-side fee estimates; should match backend config (e.g. appConfig.stripe.platformFeePercentage)
export const PLATFORM_FEE_PERCENTAGE = 5.0;
export const STRIPE_FEE_PERCENTAGE = 0.029; // 2.9%
export const STRIPE_FIXED_FEE = 0.30;

/**
 * Returns fee breakdown for display (subtotal, platform fee, stripe fee, creator receives).
 * @param {number} subtotal
 * @param {string} currency
 * @returns {{ subtotal: number, platformFee: number, platformFeePercentage: number, stripeFee: number, creatorReceives: number, currency: string } | null}
 */
export function calculateFeeBreakdown(subtotal, currency = 'USD') {
  if (subtotal === 0) {
    return {
      subtotal: 0,
      platformFee: 0,
      platformFeePercentage: PLATFORM_FEE_PERCENTAGE,
      stripeFee: 0,
      creatorReceives: 0,
      currency
    };
  }
  const platformFee = Math.round((subtotal * PLATFORM_FEE_PERCENTAGE) / 100 * 100) / 100;
  const stripeFee = Math.round((subtotal * STRIPE_FEE_PERCENTAGE + STRIPE_FIXED_FEE) * 100) / 100;
  const creatorReceives = Math.round((subtotal - platformFee - stripeFee) * 100) / 100;
  return {
    subtotal,
    platformFee,
    platformFeePercentage: PLATFORM_FEE_PERCENTAGE,
    stripeFee,
    creatorReceives,
    currency
  };
}
